import type { FaireProductEntity } from "../../entity_types/product";

export const p_uek7hwkmx5: FaireProductEntity = {
  token: "p_uek7hwkmx5",
  type: "product",
  name: "DESERT BLOSSOMS Medium Candle",
  brandToken: "b_efy227uud9",
  brandName: "CICADA",
  imageUrl:
    "https://cdn.faire.com/fastly/c7684a0f95cbbd529177a22bc4bfa87edf9a01023ada178fe0956b9ee6ead7eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19656452e55236265e5345999018d6d7b1683d84c81f2a68f375805b3c01ff2a.jpeg",
    "https://cdn.faire.com/fastly/8b9b09c9804767478041f46b71877d11bf4e6b43dcf9b0beb6b6cdbdae1c646f.jpeg",
    "https://cdn.faire.com/fastly/3b055df2d7d1ea939f41529c9ad912d715c6c5ce6b5968116d17d632b5370915.jpeg",
  ],
  priceDollars: 15,
  description:
    "(previously called scent No. 05)\n\nThe scent of desert horizons. The sun is low and smeared in violent shades of pink and ochre. It's the scent of late summer. Remember?\n\nDon’t forget to remember.\n\nNOTES\ndesert blooms + wild citrus peel + arid woods + musk\n\nBURN TIME\n45-50 hours. This single wicked candle has great hot throw and is perfect for smaller spaces.\n\n9 ounce / 255 g in glass jar candle in gift box with UPC located on bottom of box\n\nMADE BETTER\n• signature coconut-soy blend wax\n• infused with natural essential oils and phthalate-free fine fragrance\n• cotton core-less wicks (no metals!)\n• cruelty-free\n• paraben-free\n• dye-free\n• eco-friendly\n• reusable glass vessel",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:44:26.419Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
